import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import defaultImage from '../images/adicionar-usuario.png';
import checkIcon from '../images/checked.png';
import '../css/style.css';
import '../css/Cadastro.css';
import api from '../service/api';

Modal.setAppElement('#root'); // Especifique o elemento raiz do aplicativo para acessibilidade

function Cadastro({ isOpen, onRequestClose, onCadastroSuccess, alunoParaEditar }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [sexo, setSexo] = useState('masculino');
    const [telefone, setTelefone] = useState('');
    const [idade, setIdade] = useState('');
    const [profile, setProfile] = useState('homensEMulheresAdultos');
    const [foto, setFoto] = useState('');       // preview (URL do R2 ou dataURL local)
    const [fotoFile, setFotoFile] = useState(null); // arquivo a ser enviado ao R2

    const [mensagemFoto, setMensagemFoto] = useState("Adicione uma foto até 2MB");
    const [mensagemErro, setMensagemErro] = useState("");
    const [cadastroSucesso, setCadastroSucesso] = useState(false);

    // Carrega os dados do aluno caso já tenha selecionado um
    useEffect(() => {
        if (isOpen) {
            if (alunoParaEditar) {
                setName(alunoParaEditar.name || '');
                setEmail(alunoParaEditar.email || '');
                setDataNascimento(alunoParaEditar.dataNascimento || '');
                setSexo(alunoParaEditar.sexo || 'masculino');
                setTelefone(alunoParaEditar.telefone || '');
                setIdade(alunoParaEditar.idade || '');
                setProfile(alunoParaEditar.profile || 'homensEMulheresAdultos');
                setFoto(alunoParaEditar.foto || '');
                setMensagemFoto(alunoParaEditar.foto ? "Imagem carregada" : "Adicione uma foto até 2MB");
            } else {
                setName('');
                setEmail('');
                setFoto('');
            }
            setFotoFile(null);
            setMensagemErro("");
            setCadastroSucesso(false);
        }
    }, [isOpen, alunoParaEditar]);

    const navigate = useNavigate();

    // Troca a foto
    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            if (file.size > 2 * 1024 * 1024) { // 2MB em bytes
                setMensagemFoto("A imagem excedeu o limite de 2MB, selecione outra!");
                setFoto(null);
                setFotoFile(null);
                return;
            }

            setFotoFile(file); // guarda o arquivo para enviar ao R2
            const reader = new FileReader();
            reader.onload = () => {
                setFoto(reader.result); // apenas para pré-visualização
                setMensagemFoto(file.name); // Exibe o nome do arquivo carregado
            };
            reader.readAsDataURL(file);
        } else {
            setFoto(null);
            setFotoFile(null);
            setMensagemFoto("Adicione uma foto até 2MB");
        }
    };

    // Formata a data e idade
    const formatarData = (input) => {
        const digitos = input.replace(/\D/g, '');
        const dia = digitos.slice(0, 2);
        const mes = digitos.slice(2, 4);
        const ano = digitos.slice(4, 8);

        return dia + (mes ? `/${mes}` : '') + (ano ? `/${ano}` : '');
    };

    const calcularIdade = (data) => {
        const partes = data.split('/');
        if (partes.length === 3) {
            const dia = parseInt(partes[0], 10);
            const mes = parseInt(partes[1], 10) - 1;
            const ano = parseInt(partes[2], 10);

            const nascimento = new Date(ano, mes, dia);
            const hoje = new Date();
            let idadeCalculada = hoje.getFullYear() - nascimento.getFullYear();

            if (
                hoje.getMonth() < nascimento.getMonth() ||
                (hoje.getMonth() === nascimento.getMonth() && hoje.getDate() < nascimento.getDate())
            ) {
                idadeCalculada--;
            }

            return isNaN(idadeCalculada) ? "" : idadeCalculada;
        }
        return "";
    };

    const handleNascimentoChange = (e) => {
        const dataFormatada = formatarData(e.target.value);
        setDataNascimento(dataFormatada);
        setIdade(calcularIdade(dataFormatada));
    };

    // Formata o telefone
    const handleTelefoneChange = (event) => {
        let value = event.target.value;

        // Remove todos os caracteres não numéricos
        value = value.replace(/\D/g, "");

        // Aplica a máscara (XX) XXXXX-XXXX
        if (value.length > 2) {
            value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
        }
        if (value.length > 10) {
            value = `${value.slice(0, 10)}-${value.slice(10, 14)}`;
        }

        setTelefone(value);
    };

    async function handleCadastrarAluno(e) {
        e.preventDefault();

        if (!name || !dataNascimento || !sexo || !telefone || !idade || !profile) {
            setMensagemErro("Todos os campos obrigatórios devem ser preenchidos.");
            return;
        }

        else {
            const data = {
                name,
                dataNascimento,
                sexo,
                telefone,
                idade,
                profile,
                email
            };

            try {
                const response = await api.post('/api/student/new-student', data, { withCredentials: true });
                if (response.status === 200) {
                    const alunoComId = { ...data, id: response.data.id };

                    // Envia a foto ao R2 (se houver) e guarda a URL retornada.
                    if (fotoFile) {
                        try {
                            const formData = new FormData();
                            formData.append('foto', fotoFile);
                            const upload = await api.post(`/api/student/${response.data.id}/foto`, formData, { withCredentials: true });
                            alunoComId.foto = upload.data.url;
                        } catch (uploadErr) {
                            console.log(uploadErr);
                            alert('Aluno cadastrado, mas houve um erro ao enviar a foto.');
                        }
                    }

                    setCadastroSucesso(true);
                    setTimeout(() => {
                        onRequestClose();
                        navigate('/home-aluno', { state: { alunoSelecionado: alunoComId } });
                    }, 2000);
                }
            } catch (err) {
                console.log(err);
                // O servidor devolve mensagem própria em regras de negócio (ex.: limite de alunos).
                setMensagemErro(err?.response?.data?.message || 'Erro no cadastro, tente novamente!');
            };
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Cadastro de Aluno"
            className="cadastro-modal"
            overlayClassName="cadastro-overlay"
        >
            <div className="cadastro-content" id="cadastro-form-container" style={{ display: cadastroSucesso ? "none" : "block" }}>
                <p className="cadastro-title">
                    {alunoParaEditar ? "Atualizar Aluno" : "Cadastro de Aluno"}
                </p>
                <div className="cadastro-center">
                    <div className="cadastro-left">
                        <div className="form-cadastro">
                            <div className="form-label-input">
                                <label htmlFor="nome">Nome completo*</label>
                                <input id="nome" type="text" placeholder="" value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="form-label-input">
                                <label htmlFor="email">E-mail</label>
                                <input id="email" type="text" placeholder="" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="form-2-columns">
                                <div className="form-label-input">
                                    <label htmlFor="dataNascimento">Data de nascimento*</label>
                                    <input id="dataNascimento" type="text" placeholder="" value={dataNascimento} onChange={handleNascimentoChange} />
                                </div>
                                <div className="form-label-input">
                                    <label htmlFor="sexo">Sexo*</label>
                                    <select id="sexo" value={sexo} onChange={(e) => setSexo(e.target.value)}>
                                        <option value="masculino">Masculino</option>
                                        <option value="feminino">Feminino</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-2-columns">
                                <div className="form-label-input">
                                    <label htmlFor="telefone">Telefone*</label>
                                    <input id="telefone" type="text" placeholder="" value={telefone} onChange={handleTelefoneChange} />
                                </div>
                                <div className="form-label-input">
                                    <label htmlFor="idade">Idade*</label>
                                    <input id="idade" type="text" placeholder="" value={idade} readOnly />
                                </div>
                            </div>
                            <div className="form-label-input">
                                <label htmlFor="perfil">Perfil do avaliado*</label>
                                <select id="perfil" value={profile} onChange={(e) => setProfile(e.target.value)}>
                                    <option value="homensEMulheresAdultos">Homens e mulheres adultos</option>
                                    <option value="mulheresQueDesejamEmagrecer">Mulheres que desejam emagrecer</option>
                                    <option value="idosos">Idosos</option>
                                    <option value="gestantes">Gestantes</option>
                                    <option value="posParto">Pós-parto</option>
                                    <option value="obesos">Obesos</option>
                                    <option value="diabetesMelitus">Diabetes Melitus</option>
                                    <option value="hipertensaoArterial">Hipertensão arterial</option>
                                    <option value="depressao">Depressão</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="cadastro-right">
                        <input type="file" accept="image/*" onChange={handleImageChange} id="photo-upload-input" style={{ display: 'none' }} />
                        <label htmlFor="photo-upload-input">
                            {foto ? (
                                <img className="foto-cadastro" src={foto} alt="Foto do Aluno" />
                            ) : (
                                <img className="foto-cadastro" src={defaultImage} alt="Foto Padrão" />
                            )}
                        </label>
                        <p className="cadastro-foto-title">{mensagemFoto}</p>
                    </div>
                </div>
                {mensagemErro && <p className="error-message error-message-cadastro">{mensagemErro}</p>}
                <button onClick={handleCadastrarAluno} className="cadastro-button">
                    {alunoParaEditar ? "Salvar Alterações" : "Cadastrar aluno"}
                </button>

            </div>
            <div className="cadastro-content text-center" id="cadastro-sucesso-container" style={{ display: cadastroSucesso ? "block" : "none" }}>
                <p className="cadastro-title">Cadastro realizado com sucesso!</p>
                <img className="check-icon" src={checkIcon} alt="Checked" />
                <p className="redirect-title redirecionando-texto">
                    Redirecionando para tela do aluno...
                    <span className="spinner"></span>
                </p>
            </div>

        </Modal>
    );
}

export default Cadastro;
